module.exports = __webpack_public_path__ + "static/media/mycolliers icon 192.72147777.png";